import AdjustRecordingLogic from '../../components/RecordingFeatures/AdjustRecording'
import "../../css/app/aiResults.css";

const AdjustRecordingPage = () => {

    return (
        <div className="vr-air-page">
            <AdjustRecordingLogic />
        </div>
    );
};

export default AdjustRecordingPage;
